import React, { useGlobal, useState } from "reactn";
import PropTypes from "prop-types";
import Form from "./Form";
import StatusForm from "./StatusForm";
import "../../../assets/css/componentSpecificCss/eventListings.css";
import EditProgramStartDateModal from "../../../components/modals/EditProgramStartDateModal";

const BoxForm = props => {
  const [dsUser] = useGlobal("dsUser");
  const {
    fields,
    name,
    handleChange,
    removable,
    handleRemove,
    object,
    removeAfterSaved,
    formType,
    statuses,
    customForm,
    editStartDate,
    handleStartDateChange,
    programStartDate,
    onCloseStartDateModal,
    headerActions
  } = props;
  const [startDateNotificationModal, setStartDateNotificationModal] =
    useState(false);

  const canRemove = () => {
    return (
      removeAfterSaved || (!removeAfterSaved && typeof object.id !== "number")
    );
  };
  return (
    <div
      className={
        name !== "Create Ticket" &&
        name !== "Create Package" &&
        name !== "Membership Plans" &&
        name !== "Credit Card" &&
        name !== "Additional Settings" &&
        name !== "Checkout Details" &&
        name !== "Tax Rate Allotment"
          ? "box"
          : "box custom-width-box"
      }
    >
      <div className="bgofbox">
        {editStartDate && (
          <EditProgramStartDateModal
            onDateChange={date => {
              handleStartDateChange(date);
              onCloseStartDateModal();
            }}
            onClose={() => onCloseStartDateModal()}
            programStartDate={programStartDate}
          />
        )}
        <div className="header">
          <div className="row">
            <div className="col-12 d-flex" style={{ alignItems: "center", justifyContent: "space-between" }}>
              <div style={{ display: "flex", alignItems: "center" }}>
                <h2 style={{ fontSize: "17px", color: "#042470", marginBottom: "0px" }}>{name}</h2>{" "}
                {headerActions && (
                  <span style={{ marginLeft: "15px", display: "flex", alignItems: "center" }}>{headerActions}</span>
                )}
              </div>
              {(removable && canRemove()) ||
              (removable && dsUser.accountType === "Admin") ? (
                <button
                  className="remove-box"
                  onClick={() => handleRemove(object)}
                >
                  <i className="fas fa-times"></i>
                </button>
              ) : null}
            </div>
          </div>
        </div>
        {!customForm ? (
          formType === "normal" ? (
            <Form handleChange={handleChange} fields={fields} />
          ) : (
            <StatusForm
              handleChange={handleChange}
              fields={fields}
              statuses={statuses}
            />
          )
        ) : (
          customForm
        )}
      </div>
    </div>
  );
};

BoxForm.propTypes = {
  fields: PropTypes.object,
  handleChange: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  removable: PropTypes.bool,
  handleRemove: PropTypes.func,
  object: PropTypes.object,
  removeAfterSaved: PropTypes.bool,
  formType: PropTypes.string,
  statuses: PropTypes.object,
  customForm: PropTypes.any,
  headerActions: PropTypes.any
};

BoxForm.defaultProps = {
  removable: false,
  handleRemove: () => false,
  object: {},
  removeAfterSaved: true,
  formType: "normal",
  customForm: null,
  headerActions: null
};

export default BoxForm;
